<div class="bed-bath-container" [ngClass]="{ mobile: isMobile }" (clickOutside)="isOpen = false">
  <div class="input" (click)="isOpen = !isOpen">
    <div>
      <span class="selected-amount">({{ numberOfBeds ? numberOfBeds + '+' : 'All' }}) </span>
      <span class="title ml-5 mr-5">Beds &</span>
      <span class="selected-amount">({{ numberOfBaths ? numberOfBaths + '+' : 'All' }}) </span>
      <span class="title ml-5 mr-5">Baths</span>
    </div>
    <fa-icon class="ml-15" [class]="{ flip: isOpen }" icon="angle-down" />
  </div>

  @if (isOpen) {
    <div class="options-container">
      <div class="options pb-3">
        <p class="ml-5">Beds</p>
        @if (bedsFormControl) {
          <p-selectButton [options]="options" [formControl]="bedsFormControl" />
        }
        <p class="ml-5">Baths</p>
        @if (bathsFormControl) {
          <p-selectButton [options]="options" [formControl]="bathsFormControl" />
        }
      </div>
    </div>
  }
</div>
